module.exports = __webpack_public_path__ + "img/pc-img2-618.6bfd1b71.png";